angular.module('timeMask', []).directive('timeMask', ['$filter', function($filter) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attrs, ctrl) {
            const modelMode = attrs.timeMaskModel === 'minutes' ? 'minutes' : 'decimal';
            const acceptsNegative = attrs.timeMaskNegative === 'true';

            let raw = ''; // buffer de dígitos puros
            let isNegative = false;

            element.on('keydown', function(e) {

                // permitir backspace
                if (e.key === 'Backspace') {
                    if (!raw.length && acceptsNegative && isNegative) {
                        isNegative = false;
                        e.preventDefault();
                        render();
                        return;
                    }

                    raw = raw.slice(0, -1);
                    e.preventDefault();
                    render();
                    return;
                }

                // permitir tab, setas etc
                if (e.key && e.key.length > 1) return;

                if (acceptsNegative && e.key === '-') {
                    isNegative = !isNegative;
                    e.preventDefault();
                    render();
                    return;
                }

                // permitir apenas números
                if (!/^\d$/.test(e.key)) {
                    e.preventDefault();
                    return;
                }

                // acrescenta novo dígito
                raw += e.key;

                // limita máximo (999:99 -> 5 dígitos)
                raw = raw.slice(0, 5);

                e.preventDefault();
                render();
            });


            function render() {
                const formatted = formatFromRaw(raw, isNegative);
                ctrl.$setViewValue(formatted);
                ctrl.$render();
            }

            function formatFromRaw(clean, negative) {
                if (!clean) {
                    return negative ? '-' : undefined;
                }

                if (clean.length === 1) {
                    return (negative ? '-' : '') + '00:0' + clean;
                }
                if (clean.length === 2) {
                    return (negative ? '-' : '') + '00:' + clean;
                }

                const mm = clean.slice(-2);
                const hh = clean.slice(0, -2).padStart(2, '0');

                return (negative ? '-' : '') + hh + ':' + mm;
            }

            function parseViewValue(viewValue, mode) {
                if (!viewValue) return;

                const isNegativeValue = viewValue.startsWith('-');
                const sanitizedViewValue = viewValue.replace('-', '');

                if (mode === 'minutes') {
                    const hoursMinutes = sanitizedViewValue.split(/[.:]/);
                    const hours = parseInt(hoursMinutes[0], 10);
                    const minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
                    const totalMinutes = (hours * 60) + minutes;

                    return isNegativeValue ? totalMinutes * -1 : totalMinutes;
                }

                const decimalValue = Number($filter('timeStringToFloat')(sanitizedViewValue));
                return isNegativeValue ? decimalValue * -1 : decimalValue;
            }

            function formatModelValue(modelValue, mode) {
                if (modelValue === undefined || modelValue === null || modelValue === '') {
                    raw = '';
                    isNegative = false;
                    return;
                }

                isNegative = Number(modelValue) < 0;

                if (mode === 'minutes') {
                    const total = Math.abs(parseInt(modelValue, 10));
                    const hh = Math.floor(total / 60).toString();
                    const mm = (total % 60).toString().padStart(2, '0');

                    raw = hh + mm;
                    return formatFromRaw(raw, isNegative);
                }

                const total = Math.round(Math.abs(Number(modelValue)) * 60);
                const hh = Math.floor(total / 60).toString();
                const mm = (total % 60).toString().padStart(2, '0');

                raw = hh + mm;
                return formatFromRaw(raw, isNegative);
            }

            ctrl.$parsers.push(function(viewValue) {
                return parseViewValue(viewValue, modelMode);
            });

            ctrl.$formatters.push(function(modelValue) {
                return formatModelValue(modelValue, modelMode);
            });

            ctrl.$validators.time = function(modelValue, viewValue) {
                if (!viewValue) return true;

                if (viewValue === '-') {
                    return acceptsNegative;
                }

                const sanitizedViewValue = viewValue.replace('-', '');
                const [hh, mm] = sanitizedViewValue.split(':').map(Number);

                if (mm >= 60) return false;
                if (hh > 999) return false;

                return true;
            };
        }
    };
}]);
